import { payload } from 'action-creators/metrics';
import {
  CLEAR_PROFILE_FORM,
  CREATE_PROFILE_SUCCESS,
  GET_AVATARS_COLLECTIONS,
  GET_PROFILES_INFO,
  HIDE_PROFILE_LOADER,
  SET_DISPLAY_PROFILE_MODAL,
  SET_IS_LOADING_PROFILES,
  SET_PROFILE_FORM_FIELD,
  SET_PROFILE_LAYOUT_TYPE,
  SHOW_PROFILE_LOADER,
  UPDATED_PROFILE_INFO,
} from './profile.types';

// layoutTypes = SELECT_PROFILE | CREATE_PROFILE | SELECT_PROFILE_IMAGE | MANAGE_PROFILES | EDIT_PROFILE | DELETE_PROFILE

const initialState = {
  isLoading: false,
  avatars: null,
  profilesInfo: null,
  layout: 'SELECT_PROFILE',
  prevLayout: '',
  displayModal: false,
  configProfileForm: {
    firstname: '',
    user_image: '',
    is_kids: false,
    gamification_id: '',
  },
  showLoader: false,
};

export const profilesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DISPLAY_PROFILE_MODAL:
      return {
        ...state,
        displayModal: action.payload,
      };
    case SET_PROFILE_LAYOUT_TYPE:
      return {
        ...state,
        prevLayout: state.layout,
        layout: action.payload,
      };
    case GET_AVATARS_COLLECTIONS:
      return {
        ...state,
        avatars: action.payload,
        configProfileForm: {
          ...state.configProfileForm,
          user_image: action.payload[action.payload?.length - 1]?.user_image,
        },
      };
    case GET_PROFILES_INFO:
      return {
        ...state,
        profilesInfo: action.payload,
      };
    case SET_IS_LOADING_PROFILES:
      return {
        ...state,
        isLoading: action.payload,
      };
    case SET_PROFILE_FORM_FIELD:
      return {
        ...state,
        configProfileForm: {
          ...state.configProfileForm,
          ...action.payload,
        },
      };
    case CREATE_PROFILE_SUCCESS:
      return {
        ...state,
        profilesInfo: {
          ...state.profilesInfo,
          members: action.payload.newMembers,
        },
        layout: action.payload.newLayout,
      };
    case UPDATED_PROFILE_INFO:
      return {
        ...state,
        profilesInfo: {
          ...state.profilesInfo,
          members: state.profilesInfo?.members?.map(profile => {
            if (profile?.gamification_id === action.payload?.gamification_id) {
              return action.payload;
            }
            return profile;
          }),
        },
      };
    case CLEAR_PROFILE_FORM: {
      return {
        ...state,
        configProfileForm: initialState.configProfileForm,
      };
    }
    case SHOW_PROFILE_LOADER: {
      return {
        ...state,
        showLoader: true,
      };
    }
    case HIDE_PROFILE_LOADER:
      return {
        ...state,
        showLoader: false,
      };
    default:
      return state;
  }
};
